import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { readPendingTopUp } from "../checkout/topUpReturn";
import { referenceFromLocation } from "../checkout/paystackReturn";
import { FINANCE_PATH, TOP_UP_RETURN_PATH } from "./financeRoutes";

const SETTLES_ITSELF = [FINANCE_PATH, TOP_UP_RETURN_PATH, "/checkout"];

const TopUpReturnBridge = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [reference] = useState(() => referenceFromLocation(window.location.search));

  useEffect(() => {
    if (!reference || SETTLES_ITSELF.includes(pathname)) return;
    if (!readPendingTopUp()) return;

    navigate(`${FINANCE_PATH}?trxref=${encodeURIComponent(reference)}`, { replace: true });
  }, [reference, pathname, navigate]);

  return null;
};

export default TopUpReturnBridge;
